const sonic150rData = {
  slug: "sonic-150r",
  name: "Honda Sonic 150R",

  hero: {
    shortDescription:
      "Motor hyper underbone 150cc DOHC dengan performa tinggi dan desain agresif khas motor sport",

    variants: [
      {
        key: "activo-black",
        label: "Standard",
        fullName: "Honda Sonic 150R New Activo Black",
        startPrice: 28984000,
      },
      {
        key: "energetic-red",
        label: "Standard",
        fullName: "Honda Sonic 150R New Energetic Red",
        startPrice: 29389000,
      },
      {
        key: "racing-red",
        label: "Standard",
        fullName: "Honda Sonic 150R Racing Red",
        startPrice: 29389000,
      },
    ],

    slides: [
      {
        variantKey: "activo-black",
        image: "",
        specs: {
          engine: "149,16 cc",
          transmission: "Manual 6 Percepatan",
          valve: "DOHC 4 Katup",
        },
      },
      {
        variantKey: "energetic-red",
        image: "",
        specs: {
          engine: "149,16 cc",
          transmission: "Manual 6 Percepatan",
          valve: "DOHC 4 Katup",
        },
      },
      {
        variantKey: "racing-red",
        image: "",
        specs: {
          engine: "149,16 cc",
          transmission: "Manual 6 Percepatan",
          valve: "DOHC 4 Katup",
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda Sonic 150R adalah motor hyper underbone Honda dengan performa tinggi yang dirancang untuk pengendara yang menginginkan akselerasi dan handling sporty.",
      },
      {
        type: "paragraph",
        text:
          "Dibekali mesin 150cc DOHC 4 katup berpendingin cairan, Sonic 150R menawarkan performa responsif di kelasnya.",
      },
      {
        type: "heading",
        text: "Desain Sporty dan Agresif",
      },
      {
        type: "paragraph",
        text:
          "Tampilan tajam dengan bodi ramping memberikan kesan motor balap yang kuat.",
      },
      {
        type: "heading",
        text: "Performa Tinggi",
      },
      {
        type: "paragraph",
        text:
          "Transmisi 6 percepatan dan bobot ringan menjadikan Sonic 150R lincah dan bertenaga.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, DOHC, 4 Katup"],
      ["Kapasitas Mesin", "149,16 cc"],
      ["Sistem Pendingin", "Liquid Cooled"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Daya Maksimum", "11,8 kW / 9.000 rpm"],
      ["Torsi Maksimum", "13,5 Nm / 6.500 rpm"],
      ["Transmisi", "Manual, 6 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Diamond Frame"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Monoshock"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Cakram"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.941 x 669 x 977 mm"],
      ["Jarak Sumbu Roda", "1.275 mm"],
      ["Tinggi Jok", "762 mm"],
      ["Berat", "114 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "4,0 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Panel Meter", "Full Digital"],
      ["Lampu", "Full LED"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda Sonic 150R",
    items: [
      {
        title: "Mesin 150cc DOHC",
        desc:
          "Performa tinggi dengan karakter sporty dan respons cepat.",
      },
      {
        title: "Transmisi 6 Percepatan",
        desc:
          "Memberikan akselerasi optimal di berbagai kondisi.",
      },
      {
        title: "Bobot Ringan",
        desc:
          "Handling lincah dan mudah dikendalikan.",
      },
      {
        title: "Panel Meter Digital",
        desc:
          "Informasi berkendara tampil modern dan jelas.",
      },
      {
        title: "Rem Cakram Depan & Belakang",
        desc:
          "Pengereman lebih aman dan stabil.",
      },
      {
        title: "Lampu Full LED",
        desc:
          "Pencahayaan terang dengan konsumsi daya efisien.",
      },
    ],
  },
};

export default sonic150rData;
